export default "__VITE_ASSET__BEGX68IX__"